import React, { Fragment, useContext } from 'react';
import { Popover, Transition } from '@headlessui/react';
import { AccountContext } from 'context/account';
import { useFormat } from 'helpers/hooks/useFormat';
import AccountIcon from 'icons/account';
import LoginForm from 'components/commercetools-ui/organisms/authentication/login/login-form';
import Link from 'next/link';
import { Button } from 'components/ui/button';
import { useAccount } from 'frontastic';
import { useRouter } from 'next/navigation';

const AccountButton = () => {
  const { loggedIn } = useContext(AccountContext);
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });
  const { logout } = useAccount();
  const router = useRouter();

  return (
    <>
      <Link href={'/login'} data-testid="mobile-header-account-button" className="flex lg:hidden">
        <AccountIcon />
        <span className="text-nowrap pl-2 text-center text-sm font-medium">
          {formatAccountMessage({ id: 'account', defaultMessage: 'Account' })}
        </span>
      </Link>
      {!loggedIn ? (
        <Popover className={'hidden lg:block'}>
          {({ open }) => (
            <>
              <Popover.Button
                className={`${
                  open ? 'border-gray-400 border-b-[#fcfcfa] bg-[#fcfcfa]' : 'border-transparent'
                } relative z-40 flex cursor-pointer items-center rounded-t-md border px-1 py-3 text-base focus-visible:ring-2 focus-visible:ring-white/75`}
              >
                <div
                  data-testid="desktop-header-account-button"
                  className="flex flex-col items-center justify-center focus:outline-2 focus:outline-red-400"
                >
                  <div className="mb-1 size-5">
                    <AccountIcon />
                  </div>
                  <span className="text-nowrap text-xs font-semibold leading-normal">Account</span>
                </div>
              </Popover.Button>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <Popover.Panel className="absolute right-0 z-30 -mt-px max-w-[375px] origin-top-right border border-gray-400">
                  <section
                    data-testid="desktop-header-account-popup"
                    className="relative w-[373px] bg-[#fcfcfa] px-5 py-7"
                  >
                    <LoginForm isPopupMode />
                  </section>
                </Popover.Panel>
              </Transition>
            </>
          )}
        </Popover>
      ) : (
        <Link
          href={'/account'}
          data-testid="desktop-header-account-button"
          className="hidden translate-y-[3px] flex-col items-center justify-center lg:flex"
        >
          <div className="mb-1 size-5">
            <AccountIcon />
          </div>
          <span className="text-nowrap text-xs font-semibold leading-normal">Account</span>
          <Button
            onClick={() => {
              logout();
              router.push('/login');
            }}
            className="text-xs font-semibold underline"
          >
            Sign Out
          </Button>
        </Link>
      )}
    </>
  );
};

export default AccountButton;
